// src/auth/guard/guard-helpers.tsx

import React from 'react';
import ModulePermissionGuard from './module-permission-guard';
import FeatureGuard from './feature-guard';
import type { PermissionModule, PermissionAction } from '../types/permissions';

// =================================================================
// HELPER: Motor Feature + Module Permission Guard
// =================================================================

interface MotorGuardProps {
  children: React.ReactNode;
  module: PermissionModule | PermissionModule[];
  action?: PermissionAction;
}

export function MotorGuard({ children, module, action }: MotorGuardProps) {
  return (
    <FeatureGuard feature="motor">
      <ModulePermissionGuard module={module} action={action}>
        {children}
      </ModulePermissionGuard>
    </FeatureGuard>
  );
}

// =================================================================
// HELPER: App Feature + Module Permission Guard
// =================================================================

interface AppGuardProps {
  children: React.ReactNode;
  module: PermissionModule | PermissionModule[];
  action?: PermissionAction;
}

export function AppGuard({ children, module, action }: AppGuardProps) {
  return (
    <FeatureGuard feature="app">
      <ModulePermissionGuard module={module} action={action}>
        {children}
      </ModulePermissionGuard>
    </FeatureGuard>
  );
}

// =================================================================
// HELPER: Scan Feature + Module Permission Guard
// =================================================================

interface ScanGuardProps {
  children: React.ReactNode;
  module?: PermissionModule | PermissionModule[];
  action?: PermissionAction;
}

export function ScanGuard({ children, module, action }: ScanGuardProps) {
  return (
    <FeatureGuard feature="scan">
      {module ? (
        <ModulePermissionGuard module={module} action={action}>
          {children}
        </ModulePermissionGuard>
      ) : (
        children
      )}
    </FeatureGuard>
  );
}
